import React from 'react';
import './cruise-details.css';
import Guests from "../guests/guests";

class CruiseDetails extends React.Component {

    constructor(props) {
        super(props);
        this.booking = this.props.booking;
        this.showItineraryLink = this.props.showItineraryLink;
        this.showGuests = this.props.showGuests;
    }

    render = () => {
        return (
            <div className="rea-cruiseDetailsContainer">
                <div className="rea-cruiseContainer rea-block-row">
                    <div className="rea-block-12 rea-padding-0">
                        <div className="rea-sectionHeaders">Cruise Details</div>
                    </div>
                    <div className="rea-block-8 rea-padding-0">
                        <div className="rea-block-row">
                            <div className="rea-block-12 rea-bold">
                                {this.booking.itineraryDescription}
                            </div>
                            <div className="rea-block-12 rea-cruiseDetails">
                                {
                                    !this.booking.group &&
                                    <div className="rea-block-12 rea-padding-0">
                                        <div className="rea-sumLabel">
                                            Order Number:
                                        </div>
                                        <div className="rea-sumResult">
                                            {this.booking.bookingId}
                                        </div>
                                    </div>
                                }
                                {
                                    !this.booking.group &&
                                    <div className="rea-block-12 rea-padding-0">
                                        <div className="rea-sumLabel">
                                            Cruise Line Res Number:
                                        </div>
                                        <div className="rea-sumResult">
                                            {this.booking.reservationNumber}
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="rea-block-12 rea-cruiseDetails">
                                <div className="rea-block-12 rea-padding-0">
                                    <div className="rea-sumLabel">
                                        Cruise Line/Ship:
                                    </div>
                                    <div className="rea-sumResult">
                                        {this.booking.supplierName} / {this.booking.shipName}
                                    </div>
                                </div>
                                <div className="rea-block-12 rea-padding-0">
                                    <div className="rea-sumLabel">
                                        Departs:
                                    </div>
                                    <div className="rea-sumResult">
                                        {this.booking.embarkationPort}
                                    </div>
                                </div>
                                <div className="rea-block-12 rea-padding-0">
                                    <div className="rea-sumLabel">
                                        Travel Dates:
                                    </div>
                                    <div className="rea-sumResult">
                                        {new Intl.DateTimeFormat('en-US', {
                                            year: 'numeric',
                                            month: 'short',
                                            day: '2-digit'
                                        }).format(new Date(this.booking.tripStartDate))} - {new Intl.DateTimeFormat('en-US', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: '2-digit'
                                    }).format(new Date(this.booking.tripEndDate))}
                                    </div>
                                </div>
                                {
                                    !this.booking.group &&
                                    <div className="rea-block-12 rea-padding-0">
                                        <div className="rea-sumLabel">
                                            Cabin:
                                        </div>
                                        <div className="rea-sumResult">
                                            {this.booking.cabinNumber} - {this.booking.categoryDescription}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="rea-block-4 rea-detailsImgContainer">
                        <div className="rea-detailsImg">
                            {this.showItineraryLink &&
                            <a className="rea-itineraryBtn btn wth2-ui-btn" href={this.booking.itineraryLinkUrl}
                               target="_blank" rel="noopener noreferrer">
                                View Itinerary
                            </a>}
                            <div className="rea-shipImg">
                                <img src={this.booking.productImageUrl} width="250" height="140" alt="Cruise ship"/>
                            </div>
                        </div>
                    </div>
                </div>
                {this.showGuests &&
                <Guests guests={this.booking.guests}/>
                }
            </div>
        );
    }

    getUrl = () => {
        const domainParts = window.location.hostname.split('.');
        domainParts[0] = 'help';
        return 'https://'+domainParts.join('.');
    }
}

export default CruiseDetails;
